"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _BaseBlogsSettingsContainer = _interopRequireDefault(require("./containers/BaseBlogsSettingsContainer"));

var _BlogRedirectContainer = _interopRequireDefault(require("./containers/BlogRedirectContainer"));

var _GeneralSettingsContainer = _interopRequireDefault(require("./containers/general/GeneralSettingsContainer"));

var _DateFormatsContainer = _interopRequireDefault(require("./containers/dateFormats/DateFormatsContainer"));

var _SocialSharingContainer = _interopRequireDefault(require("./containers/socialSharing/SocialSharingContainer"));

var _TemplatesContainer = _interopRequireDefault(require("./containers/templates/TemplatesContainer"));

var _CommentsContainer = _interopRequireDefault(require("./containers/comments/CommentsContainer"));

var _SubscriptionsContainer = _interopRequireDefault(require("./containers/subscriptions/SubscriptionsContainer"));

var _GoogleAMPContainer = _interopRequireDefault(require("./containers/amp/GoogleAMPContainer"));

var _tracking = require("settings-ui-app/utils/tracking");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _default = _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.BLOGS,
  component: _BaseBlogsSettingsContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)()
}, _react.default.createElement(_reactRouter.IndexRoute, {
  component: _BlogRedirectContainer.default
}), _react.default.createElement(_reactRouter.Route, {
  path: ":id"
}, _react.default.createElement(_reactRouter.IndexRoute, {
  component: _GeneralSettingsContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('default')
}), _react.default.createElement(_reactRouter.Route, {
  path: "default",
  component: _GeneralSettingsContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('default')
}), _react.default.createElement(_reactRouter.Route, {
  path: "dateFormats",
  component: _DateFormatsContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('dateFormats')
}), _react.default.createElement(_reactRouter.Route, {
  path: "socialSharing",
  component: _SocialSharingContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('socialSharing')
}), _react.default.createElement(_reactRouter.Route, {
  path: "templates",
  component: _TemplatesContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('templates')
}), _react.default.createElement(_reactRouter.Route, {
  path: "comments",
  component: _CommentsContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('comments')
}), _react.default.createElement(_reactRouter.Route, {
  path: "subscriptions",
  component: _SubscriptionsContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('subscriptions')
}), _react.default.createElement(_reactRouter.Route, {
  path: "googleAmp",
  component: _GoogleAMPContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('googleAmp')
})));

exports.default = _default;
module.exports = exports.default;